import { CARREGAR_ETNIA_SUCESSO } from './actionTypes';
import IEtnia from '../interfaces/IEtnia';

export const carregarEtniaSucesso = (etnias: IEtnia[]) => {
  return {
    type: CARREGAR_ETNIA_SUCESSO,
    state: etnias
  };
};